import { Button } from '@mui/material';
import styled from 'styled-components';
import { CheckCircle } from '@mui/icons-material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Description = styled.div`
  font-size: 14px;
  color: var(--light-opacity-gray);
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const ButtonDefault = styled(Button)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  gap: 8px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 15px;
  padding: 8px 22px;
  text-transform: none;

  &:disabled {
    border: none;
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.26);
    background-color: rgba(0, 0, 0, 0.12);
    &:hover {
      opacity: 0.5;
    }
  }
`;

export const ButtonCancel = styled(ButtonDefault)`
  border: 1px solid var(--luft-secondary-gray);
  color: var(--luft-primary);
`;

export const ButtonActivate = styled(ButtonDefault)`
  border: 1px solid var(--luft-secondary-gray);
  background-color: var(--luft-primary);
  color: #fff;
  &:hover {
    background-color: var(--luft-primary-darker);
  }
`;

export const SuccessText = styled(Description)`
  font-size: 16px;
  display: flex;
  gap: 16px;
`;

export const SuccessCircleIcon = styled(CheckCircle)`
  color: var(--luft-primary);
`;
